import { render, staticRenderFns } from "./SliderIntroWithBg.vue?vue&type=template&id=67061b19&scoped=true"
import script from "./SliderIntroWithBg.vue?vue&type=script&lang=js"
export * from "./SliderIntroWithBg.vue?vue&type=script&lang=js"
import style0 from "./SliderIntroWithBg.vue?vue&type=style&index=0&id=67061b19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67061b19",
  null
  
)

export default component.exports